module FieldOfficeFactory
{
	export function GetCitiesByState(state: States, successCallback: (Cities: string[]) => any, failureCallback: () => any)
	{
		const parameters = {
			state: state
		};
		$.ajax("/Api/SocialSecurity/Offices/Field/GetFieldOfficeCitiesByState", {
      data: $.param(parameters),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      type: "GET",
      timeout: 5000,
      success: successCallback,
      error: failureCallback
    });
	}

	export function GetFieldOfficesByStateCity(state: States, city: string, successCallback: (FieldOffices: IFieldOffice[]) => any, failureCallback: () => any)
	{
		const parameters = {
			state: state,
			city: city
		};
		$.ajax("/Api/SocialSecurity/Offices/Field/GetFieldOfficesByCityState", {
      data: $.param(parameters),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      type: "GET",
      timeout: 5000,
      success: successCallback,
      error: failureCallback
    });
	}
}